import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilService} from '../../service/util.service';
import {Observable} from 'rxjs';
import {Downloads} from '../../model/downloads';
import {Product} from '../../model/product';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css']
})
export class DownloadsComponent implements OnInit {

  downloads: Observable<Downloads[]>;

  constructor(private http: HttpClient, private util: UtilService) {
  }

  ngOnInit(): void {
    this.getDownloads();
  }

  getDownloads() {
    this.downloads =  this.http.get<Downloads[]>(this.util.getUrl('files.json'));
  }
}
